export default __webpack_public_path__ + "static/media/css.3a934b5f.png";